import useMediaQuery from '@mui/material/useMediaQuery';

export const useDesktopMode = () => {
    const desktopMode = useMediaQuery('(min-width:600px)');

    return desktopMode;
};
